// extracted by mini-css-extract-plugin
module.exports = {"root":"IconTowel_root__3ymwT"};